import React, { useEffect, useState, useContext } from "react";
import { Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { fetchArticlesByPromotion } from "../../../api/articles";
import ProductPromotionsTable from "../../../components/products-promotion-table/ProductPromotionsTable";
import { toast } from "../../../helpers/smu-alerts/smu-lerts";
import { fetchFaldonesByPromotionData } from "../../../api/files";
import { StoreContext } from "../../../store/StoreContext";
import { useLocation } from "react-router-dom";
import { resolveUserTienda } from "../../../helpers";
import { SMU_FILTER, SMU_SELECTED_MENU, SMU_PRESERVE_PROMOTION_FILTERS } from "../../../constants";

const brand = process.env.REACT_APP_BRAND || "UNI";

const PromotionDetail = () => {
  const location = useLocation();
  const filter = JSON.parse(localStorage.getItem(SMU_FILTER));
  const promoData = location.state?.promoData;
  const selectedMenuState = location.state?.selectedMenu;
  const { promotionId } = useParams();
  const { isAdmin, loggedUser } = useContext(StoreContext);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [categoryMenu, setCategoryMenu] = useState(null);

  // Clear filters when entering this view (except formato_impresion)
  // BUT preserve filters if navigating from PromotionsTable
  useEffect(() => {
    const preserveFlag = localStorage.getItem(SMU_PRESERVE_PROMOTION_FILTERS);
    if (preserveFlag === "true") {
      // Don't clear filters - preserve them for navigation between these views
      return;
    }
    
    const currentFilter = JSON.parse(localStorage.getItem(SMU_FILTER) || '{}');
    const formatoImpresion = currentFilter?.formato_impresion || "cuarto-pagina";
    // Reset all filter values to "" while preserving formato_impresion
    const clearedFilter = {
      tienda: "",
      ean: "",
      f_categoria: "",
      f_marca: "",
      f_producto: "",
      fecha_publicacion_desde: "",
      fecha_publicacion_hasta: "",
      fecha_inicio_desde: "",
      fecha_inicio_hasta: "",
      fecha_fin_desde: "",
      fecha_fin_hasta: "",
      formato_impresion: formatoImpresion,
      keyword: "",
      p_nombre_producto: "",
      p_seccion: "",
      p_linea: "",
      p_categoria: "",
      f_negocio: ""
    };
    localStorage.setItem(SMU_FILTER, JSON.stringify(clearedFilter));
  }, []);

  useEffect(() => {
    if (!promotionId) {
      return toast({ icon: "error", title: "Error en Id de Promoción." });
    }
    setLoading(true);
    // fetchArticlesByPromotion(brand, _code)
    //   .then(({ data, error }) => {
    //     if (!!error) throw new Error(error?.message);
    //     setArticles(data.O_ARTICULOS);
    //   })
    //   .catch((err) => {
    //     console.error(err);//toast({ icon: "error", title: err });
    //   })
    //   .finally(() => setLoading(false));
    // TODO: Implementar la logica para traer los productos de la promocion
    const tienda = filter?.tienda ? filter?.tienda : resolveUserTienda(isAdmin, loggedUser);

    // Resolve category_menu either from navigation state or from localStorage
    let menuId = null;
    const rawMenu = selectedMenuState || localStorage.getItem(SMU_SELECTED_MENU);
    if (rawMenu) {
      try {
        const parsedMenu = JSON.parse(rawMenu);
        const id = parsedMenu?.id;
        if (id !== null && id !== undefined && id !== 0) {
          menuId = id;
        }
      } catch (err) {
        console.error("Error parsing selected menu in PromotionDetail:", err);
      }
    }
    setCategoryMenu(menuId);
    // Get today's date in YYYY-MM-DD format
    const today = new Date();
    const todayFormatted = today.toISOString().split('T')[0];
    const ean = filter?.ean ? filter.ean : "";
    var filters = { 
      end_date_from: todayFormatted,
      start_date_to: todayFormatted
    }
    if (ean) filters.eans = [ean];
    if (tienda !== -1) filters.tienda = tienda;
    if (menuId !== null) filters.category_menu = menuId;
    fetchFaldonesByPromotionData(promotionId, loggedUser?.username, promoData?.NEGOCIO, filter?.formato_impresion, promoData?.NOMBRE_CAMPANA, filters)
    .then(({ data, error }) => {
      if (!!error) throw new Error(error?.message);
      setProducts(data);
    })
    .catch((err) => {
      console.error(err);
    })
    .finally(() => {
        setLoading(false)});
  }, []);

  const handleApplyFilters = async (filterInput) => {
    setLoading(true);
    const filtersWithMenu = {
      ...filterInput,
      ...(categoryMenu !== null && filterInput.category_menu == null
        ? { category_menu: categoryMenu }
        : {}),
    };
    await fetchFaldonesByPromotionData(
      promotionId,
      loggedUser?.username,
      promoData?.NEGOCIO,
      filtersWithMenu.formato_impresion,
      promoData?.NOMBRE_CAMPANA,
      filtersWithMenu
    )
    .then(({ data, error }) => {
      if (!!error) throw new Error(error?.message);
      setProducts(data);
    })
    .catch((err) => {
      console.error(err);
    })
    .finally(() => {
      setLoading(false);
    });
  }

  return (
    <Row>
      <Col col={12} className="mb-4">
        <ProductPromotionsTable
          products={products}
          promotionData={promoData}
          loading={loading}
          filter={filter || null}
          handleApplyFilters={handleApplyFilters}
        />
      </Col>
    </Row>
  );
};

export default PromotionDetail;